import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=320aae7e"
import script from "./WishListCount.vue?vue&type=script&lang=js"
export * from "./WishListCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports